import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import aboutImage from '../../assets/images/about.png';
import blogImage from '../../assets/images/blog.png';
import contactImage from '../../assets/images/contact.png';
import projectsImage from '../../assets/images/projects.png';

import GridCard from './GridCard';

export default function GridCards() {
  const { t } = useTranslation();

  return (
    <Grid
      container
      rowSpacing={styles.containerRowSpacing}
      sx={styles.container}
    >
      <Grid item xs={12} sm={12} md={6}>
        <GridCard
          title={t('home.projects.title')}
          subtitle={t('home.projects.checkOut')}
          imagePath={projectsImage}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <GridCard
          title={t('home.about.title')}
          subtitle={t('home.about.checkOut')}
          imagePath={aboutImage}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <GridCard
          title={t('home.blog.title')}
          subtitle={t('home.blog.checkOut')}
          imagePath={blogImage}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <GridCard
          title={t('home.contact.title')}
          subtitle={t('home.contact.checkOut')}
          imagePath={contactImage}
        />
      </Grid>
    </Grid>
  );
}

const styles = {
  container: {
    maxWidth: 750,
    textAlign: 'center',
    margin: '0 auto',
  },
  containerRowSpacing: { xs: 1, sm: 2, md: 3 },
};
